import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-draw';
import { MapService } from '../map.service';
import { MapStyleService } from '../map-style.service';
declare const Spain_PNOA_Ortoimagen: any;
declare const Spain_MapasrasterIGN: any;
declare const Spain_IGNBase: any;
declare const Spain_MDT_Elevaciones: any;
declare const Spain_Catastro: any;
declare const Spain_UnidadAdministrativa: any;

@Component({
  selector: 'app-map-prueba',
  templateUrl: './map-prueba.component.html',
  styleUrls: ['./map-prueba.component.css']
})
export class MapPruebaComponent implements OnInit, AfterViewInit {
  private MAP_ID = 'map3';

  private map: any;

  constructor(private mapService: MapService, private mapStyleService: MapStyleService) { }

  ngAfterViewInit(): void {
    this.map = L.map(this.MAP_ID, this.mapService.getDefaultCreateFarmMapOptions());
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    L.control.layers(this.mapService.getBaseLayers()
    , this.mapService.getOverLayers(), { collapsed: false }).addTo(this.map);

    //crear iconos de leaflet.draw
    const drawnItems = new L.FeatureGroup();
    this.map.addLayer(drawnItems);

    //modificar los textos del tooltip y toolbar
    this.mapStyleService.getDrawCustomOptions();

    //Asignar propiedades al toolbar
    const drawControl = this.mapStyleService.getDrawControlFarms(drawnItems, false);
    this.map.addControl(drawControl);

    this.map.on(L.Draw.Event.CREATED, (e)  =>{
      const layer = e.layer;
      const latlang = layer._latlngs[0][0];
      const popup = L.popup()
        .setLatLng(latlang)
        .setContent("<p style='color: #5e9ca0; text-align: center;'><strong>Finca creada</strong></p>"+
        "<p style='text-align: center;'>&nbsp;Pulse siguiente para confirmar los datos</p>")
        .openOn(this.map);
      layer.openPopup(popup);
      drawnItems.addLayer(layer);
  });
  }

  private setLayers() {
    const baselayers = {
      "PNOA Máx. Actualidad": Spain_PNOA_Ortoimagen,
      "Mapas IGN": Spain_MapasrasterIGN,
      "IGN Base": Spain_IGNBase,
      "MDT Elevaciones": Spain_MDT_Elevaciones,
      "Catastro": Spain_Catastro
    };
    const overlayers = {
      "Unidades administrativas": Spain_UnidadAdministrativa
    };
    L.control.layers(baselayers, overlayers, { collapsed: false }).addTo(this.map);
  }

  configureDefaultLayers() {
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
    L.control.layers(this.mapService.getTileLayers(), {}).addTo(this.map);
  }

  ngOnInit(): void {
  }

  onDraw(){

    const polygonDrawer = new L.Draw.Polygon(this.map);
    polygonDrawer.enable();
    
  }

}
